import { DynComponentMapping } from '@ups/xplat/dynamic-render';
import {
  DynamicCoachingComponent,
  DynamicCommentComponent,
  DynamicLastModifiedComponent,
  DynamicReviewComponent,
} from './components';

/* eslint-disable @typescript-eslint/naming-convention */
export const DYNAMIC_COMPONENT_MAPPING: DynComponentMapping = {
  coaching: DynamicCoachingComponent,
  comment: DynamicCommentComponent,
  'last-modified': DynamicLastModifiedComponent,
  review: DynamicReviewComponent,
};
